export default __webpack_public_path__ + "static/media/B2_11.0853fa9b.mp3";